import PermissionSection from './PermissionSection';
import { Panel } from './types';
import { useState } from 'react';

interface RolesPermissionsProps {
  panels?: Panel[];
}

const RolesPermissions = ({ panels }: RolesPermissionsProps) => {
  const [newPanel, setnewPanel] = useState(panels);

  const setSelectedPermission = (
    previous: string,
    selectedOption: any,
    label: string,
    panelUuid: string
  ) => {
    // Map through the newPanel array
    const updatedPanels = newPanel?.map((panel) => {
      // Check if the current panel has the matching panelUuid
      if (panel.uuid === panelUuid) {
        // If it matches, update the permissions array
        const updatedPermissions = panel.permissions.map((permission) => {
          // Update the uuid and name properties if the permission matches the label
          if (permission.uuid === previous) {
            return {
              ...permission,
              uuid: selectedOption,
              name: label,
            };
          }
          return permission; // Return unchanged permission if it doesn't match
        });

        // Return the updated panel with the updated permissions
        return {
          ...panel,
          permissions: updatedPermissions,
        };
      }
      return panel; // Return unchanged panel if it doesn't match the panelUuid
    });

    // Update the state with the updated panels
    setnewPanel(updatedPanels);
  };

  return (
    <section>
      <section className="flex gap-3 mt-3">
        {newPanel?.map((panelito) => (
          <PermissionSection
            key={panelito.uuid}
            panel={panelito}
            setNewPanel={setSelectedPermission}
          />
        ))}
      </section>
    </section>
  );
};

export default RolesPermissions;
